import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import DropdownSelect from '@/components/fields/DropdownSelect';
import Field from '@/components/fields/Field';
import TextInput from '@/components/fields/TextInput';
import { useIsMidotUser } from '@/hooks/permissions/useIsMidotUser';
import MidotUserDropdownSelect from '@/views/fields/UserDropdownSelect/MidotUserDropdownSelect';

import { getLanguageOptions } from './options';

const MoreInfoTab: React.FC = () => {
  const { t } = useTranslation(['organizations', 'common']);
  const languageOptions = useMemo(() => getLanguageOptions(t), [t]);
  const { isMidotUser } = useIsMidotUser();

  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        p: 4,
        pt: 2,
        '& .MuiFormControl-root': {
          p: 0
        }
      }}
      gap={3}
    >
      <Field
        component={MidotUserDropdownSelect}
        name="keyAccountManagers"
        label={t('layouts.organizations.create.fields.keyAccountManagers')}
        markAsRequired
        innerProps={{
          isMulti: true,
          usePortal: true
        }}
        withFormControl
      />

      <Field
        component={DropdownSelect}
        name="locales"
        label={t('layouts.organizations.create.fields.primaryLanguages')}
        markAsRequired
        innerProps={{
          isMulti: true,
          usePortal: true,
          options: languageOptions
        }}
        withFormControl
      />

      {isMidotUser && (
        <>
          <Field
            component={TextInput}
            name="jiraId"
            label={t('layouts.organizations.create.fields.jiraAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />

          <Field
            component={TextInput}
            name="legacyId"
            label={t('layouts.organizations.create.fields.oldPodiumAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />

          <Field
            component={TextInput}
            name="pipedriveId"
            label={t('layouts.organizations.create.fields.pipedriveAccountNumber')}
            innerProps={{ numbersOnly: true }}
            withFormControl
          />
        </>
      )}
    </Stack>
  );
};

export default MoreInfoTab;
